import { makeStyles } from '@material-ui/core';
import img from '../../Assets/images/NotFound/notfound.png';

export const useStyle = makeStyles(theme => {
	const {
		spacing,
		breakpoints: { down },
	} = theme;
	return {
		root: {
			background: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ) , url('${img}')`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			width: '100%',
		},
		container: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			fontSize: '30px',
			color: 'white',
			height: '100vh',
			[down('md')]: {
				textAlign: 'center',
			},
			[down('sm')]: {
				marginTop: spacing(-5),
			},
			'& button': {
				[down('sm')]: {
					width: '50vw',
				},
			},
		},
		header: {
			fontFamily: 'BodoniMT',
			fontSize: '350px',
			[down('md')]: {
				fontSize: '200px',
			},
			[down('sm')]: {
				fontSize: '7rem',
				marginBottom: spacing(2),
			},
		},
		content: {
			fontFamily: 'Montserrat',
			fontSize: '20px',
			lineHeight: '30px',
			marginBottom: '12px',
			[down('md')]: {
				fontSize: '16px',
			},
			[down('sm')]: {
				fontSize: '1.1rem',
				marginBottom: spacing(4),
				fontWeight: '300',
				opacity: '0.9',
			},
		},
	};
});
